import Vue from 'vue';
import service from './base.service'
import {AxiosPromise} from 'axios';
import {AppResponse} from '@/share/response';
import {ForgotPasswordFormDto, ResetPasswordFormDto, UserModel} from "@/share";

export class AuthService extends Vue {
  private RESOURCE = 'auth';

  public getCurrentUser(): AxiosPromise<AppResponse<UserModel>> {
    return service.get<AppResponse<any>>(this.RESOURCE + '/current-user');
  }

  public login(payload: any): AxiosPromise<AppResponse<UserModel>> {
    return service.post<AppResponse<any>>(this.RESOURCE + '/login', payload);
  }

  public logout(): AxiosPromise<AppResponse<UserModel>> {
    return service.post<AppResponse<any>>(this.RESOURCE + '/logout');
  }

  public register(payload: any): AxiosPromise<AppResponse<UserModel>> {
    return service.post<AppResponse<any>>(this.RESOURCE + '/register', payload);
  }

  public forgotPassword(payload: ForgotPasswordFormDto): AxiosPromise<AppResponse<any>> {
    return service.post<AppResponse<any>>(`${this.RESOURCE}/forgot-password`, payload);
  }

  public resetPassword(payload: ResetPasswordFormDto): AxiosPromise<AppResponse<any>> {
    return service.post<AppResponse<any>>(`${this.RESOURCE}/change-password`, payload);
  }
}
